import script from "./select.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./select.vue?vue&type=script&setup=true&lang=js"
export * from "./select.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./select.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__